import React from 'react'
import ReactEcharts from "echarts-for-react";
import "../../../DisbursementModule/disbursment.scss"

type AppProps={
    totalAmount:number;
    remainingAmount:number;
}

const DisbursmentPieChart = ({
    totalAmount,
    remainingAmount
}:AppProps) => {

  let colorPalette = ['#744bd1', '#c3ceda']

  const getOptions = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      top: '50%',
      left: '2%',
      orient: 'vertical',
      selectedMode: false
  },
    series: [
      {
        name: 'Disbursment',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data: [
          { value: totalAmount, name: 'Total Amount' },
          { value: remainingAmount, name: 'Remaining Amount' },
        ],
        color:colorPalette
      }
    ]
  };

  return (
    <div className='disbursment-pie-chart'>
      <div className="summary"></div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",backgroundColor:"#f3f6f8"}}>
        <div style={{width:"50%"}}>
        <ReactEcharts option={getOptions} style={{ height: 200 }} />
        </div>
        
        <div style={{marginRight:"20%"}}>

            <div className='flex-center' style={{flexDirection:"column",alignItems:"flex-start",gap:"12px"}}>
            <div className='total-pending'>Amount By Status</div>

            <div className='total-pending-amt' >Total Amount : {totalAmount}</div>
         
            <div className=" total-pending-amt">Remaining Amount : {remainingAmount}</div>
            </div>
            
            
        </div>
    </div>
    </div>
   
  )
}

export default DisbursmentPieChart



